module.exports = new __parcel__URL__("righteoushammer.f88a55ec.png").toString();